// components/PageTracker.tsx - Component for automatic page tracking
import { usePageTracking } from '../hooks/usePageTracking.ts';

interface PageTrackerProps {
  pageTitle?: string;
  category?: string;
  trackOnMount?: boolean;
  trackOnUnmount?: boolean;
}

export const PageTracker: React.FC<PageTrackerProps> = ({
  pageTitle,
  category,
  trackOnMount = true,
  trackOnUnmount = true // Changed back to true if you want time tracking by default
}) => {
  usePageTracking({
    pageTitle,
    category,
    trackOnMount,
    trackOnUnmount
  });

  return null; // This component doesn't render anything
};

export default PageTracker;
